<hr>
<div class="row">
    <div class="col-12 col-xl-12">
        <!-- Card -->
        <div>
            <p class="mb-0 text-center">
                <span>
                    {{ message }}
                </span>
            </p>
        </div>
    </div>
</div>